<template>
  <w-sliding-popup ref="slidingPopup" type="setting" title="WAS 인스턴스 변경" @close="closePopup" width="500px">
    <el-form slot="content" :ref="formName" :model="keyTrsInfo" :rules="rules" label-position="top">
      <el-form-item label="비즈니스명" prop="bizName">
        <el-input :disabled="true" v-model="keyTrsInfo.bizName" />
      </el-form-item>
      <el-form-item label="웹 서비스 URL" prop="webSvcUrl">
        <el-input :disabled="true" v-model="keyTrsInfo.webSvcUrl" />
      </el-form-item>
      <el-form-item label="키 트랜잭션명" prop="keyTrsName">
        <el-input v-model="keyTrsInfo.keyTrsName" placeholder="입력해 주십시오."></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="!disabledSaveBtn" @click="saveKeyTrs">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { clone, isEqual } from 'lodash';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';

export default {
  name: 'WUpdateKeyTrsPopup',
  data() {
    return {
      formName: 'keyTrsForm',
      keyTrsInfo: {},
      originalkeyTrsInfo: {},
      rules: {
        keyTrsName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
    };
  },
  computed: {
    disabledSaveBtn() {
      return !isEqual(this.originalkeyTrsInfo, this.keyTrsInfo);
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open(info) {
      this.$refs.slidingPopup.visible = true;
      this.keyTrsInfo = info;
      this.originalkeyTrsInfo = clone(info);
    },
    saveKeyTrs() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          ApmSettingAPI.updateKeyTrsList(this.keyTrsInfo).then((response) => {
            if (response.data.success) {
              this.$emit('reloadData');
              this.closePopup();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '키 트랜잭션', response.data.success));
          });
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주십시오.'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/UpdateKeyTrsPopup.vue